import { Matrix3d } from "../Matrix3d.js";
import { Rect } from "../Rect.js";
import { Transform } from "../Transform.js";
import { ITransformMode } from "./ITransformMode.js";

export class TransformModeRectangle implements ITransformMode {
    public extract(transform: Transform, matrix: Matrix3d): void {
        var globalBounds = Rect.getBounds(transform.element);
        matrix.prependPosition(globalBounds.x, globalBounds.y, 0);

        // console.log(transform.style.width, transform.element.offsetWidth);
        // console.log(transform.style.height, transform.element.offsetHeight);
        // let ew = transform.element.offsetWidth;
        // let eh = transform.element.offsetHeight;
        let ew = parseFloat(transform.style.width);
        let eh = parseFloat(transform.style.height);

        var scX = NaN;
        if (globalBounds.width !== ew
            && ew !== 0) {
            scX = globalBounds.width / ew;
        }

        var scY = NaN;
        if (globalBounds.height !== eh
            && eh !== 0) {
            scY = globalBounds.height / eh;
        }

        if (isNaN(scX) && isNaN(scY)) {
            scX = 1;
            scY = 1;
        }
        else if (isNaN(scX)) {
            scX = scY;
        }
        else if (isNaN(scY)) {
            scY = scX;
        }

        if (scX !== 1 || scY !== 1) {
            matrix.appendScale(scX, scY, 1);
        }
    }

    // public extract(transform: Transform, matrix: Matrix3d): void {
    //     var globalBounds = Rect.getBounds(transform.element);
    //     matrix.prependPosition(globalBounds.x, globalBounds.y, 0);
    //     var scX = 1;
    //     if (globalBounds.width !== transform.element.offsetWidth
    //         && transform.element.offsetWidth !== 0) {
    //         scX = globalBounds.width / transform.element.offsetWidth;
    //     }
    //     var scY = 1;
    //     if (globalBounds.height !== transform.element.offsetHeight
    //         && transform.element.offsetHeight !== 0) {
    //         scY = globalBounds.height / transform.element.offsetHeight;
    //     }
    //     if (scX !== 1 || scY !== 1) {
    //         matrix.appendScale(scX, scY, 1);
    //     }
    // }
}